// src/components/layouts/LayoutPublic.vue
<template>
  <div class="layout-public">
    <router-view />
    <Footer />
  </div>
</template>

<script setup>
import Footer from "@/components/Footer.vue";
</script>

<style>
.layout-public {
  min-height: 100vh;
  padding: 50px 20px;
}
</style>
